/*
 * @Author: 南岸有归
 * @Date: 2020-02-24 09:24:27
 * @LastEditTime: 2020-03-27 09:43:24
 * @LastEditors: 南岸有归
 * @Description: 
 * @FilePath: \cloud_frontend\src\views\task\SoftwarePackage\TableConfig.js
 * @
 */
import i18n from "../../../common/lang";
export const Columns=[
    {LabelName:i18n.t('lang.softwarepackage.Software'),key:0,ColumnsKey:'spName',seek:'spName',placeholder:i18n.t('lang.softwarepackage.search1'), sort: 'custom'},
    {LabelName:i18n.t('lang.softwarepackage.Version'),key:1,ColumnsKey:'spVersion',seek:'spVersion',placeholder:i18n.t('lang.softwarepackage.search2'), sort: 'custom'},
    {LabelName:i18n.t('lang.softwarepackage.types'),key:2,ColumnsKey:'spType',seek:'spType',placeholder:i18n.t('lang.softwarepackage.search3'),Fun:'GetSoftwareType', sort: 'custom'},
    {LabelName:i18n.t('lang.softwarepackage.SoftwareSize'),key:3,ColumnsKey:'spSize',seek:'spSize',placeholder:i18n.t('lang.softwarepackage.search4'), sort: 'custom'},
    {LabelName:i18n.t('lang.softwarepackage.adminhelpuploadusers'),key:4,ColumnsKey:'username',seek:'username',placeholder:i18n.t('lang.softwarepackage.search5'),Fun:'GetUsername', sort: 'custom'},
    {LabelName:i18n.t('lang.softwarepackage.m_UploadOMeter'),key:5,ColumnsKey:'spCreate',seek:'spCreate',placeholder:i18n.t('lang.softwarepackage.search6'), sort: 'custom'},
    {LabelName:i18n.t('lang.softwarepackage.SynchronizationStatus'),align:'center', key:6,ColumnsKey:'spSynStatus',seek:'spSynStatus',placeholder:i18n.t('lang.softwarepackage.search7'),Tag:true,Fun:'GetStatus', sort: 'custom'}
]

export const ColuumnsButton=[
    {key:0,type:'primary',icon:'icon-mingpian',Fun:'SetFirmwarePermission',Authority:121},
    {key:1,type:'primary',icon:'icon-xiazai',Fun:'DownloadFile',Authority:120},
    {key:2,type:'primary',icon:'el-icon-edit',Fun:'showcenterDialogVisibles',Authority:186},
    {key:3,type:'danger',icon:'el-icon-delete',Fun:'delSoftwarePackage',Delete:true,Authority:122}
]
